<template>
  <div class="YourDevice">
    <MainPageHeader v-if="!isAndroidContext"/>
    <div v-if="getProductId === '3' || getProductId === '4'"
         :class="{'android-content': isAndroidContext}" class="content">
      <header v-if="!isAndroidContext" class="main-header">
        <p class="font-size-middle">Krok 1 z 4</p>
      </header>
      <div v-if="!isAndroidContext" class="divider"/>
      <div v-if="!isAndroidContext" class="text-header">
        <h1 class="font-size-big">Zweryfikuj urządzenie</h1>
      </div>
      <section class="section section-1">
        <div v-if="isLoading" class="loader"></div>
        <div v-else>
          <div class="no-device" v-if="device === null">
            <h1 class="font-size-big">
              <span class="highlight">Vocale</span> gwarantuje niezawodność!
            </h1>
            <span class="description">sprawdź czy Twoje urządzenie spełnia niezbędne wymagania</span>
            <BigButton @click="goToPlaystore" class="big-button" borderColor="primary">Pobierz Vocale</BigButton>
          </div>
          <div v-else>
            <h2>Parametry Twojego urządzenia:</h2>
            <table class="comparing">
              <tr>
                <td></td>
                <td>Wymagana</td>
                <td>Twoje urządzenie</td>
              </tr>
              <tr>
                <td>Wersja Android</td>
                <td>Android 8</td>
                <td
                    :class="[ requirements.androidVersion === true ? 'pass' : 'no-pass' ]">
                    Android {{ device.androidVersion }}
                </td>
                <td>
                  <font-awesome-icon
                      class="icon check"
                      icon="check-circle"
                      v-if="requirements.androidVersion === true" />
                  <font-awesome-icon
                      class="icon times"
                      icon="times-circle"
                      v-else />
                </td>
              </tr>
              <tr>
                <td>Ilość pamięci RAM</td>
                <td>4GB</td>
                <td
                    :class="[ requirements.ram === true ? 'pass' : 'can-pass' ]">
                    {{ device.ram }}GB
                </td>
                <td>
                  <font-awesome-icon
                      class="icon check"
                      icon="check-circle"
                      v-if="requirements.ram === true" />
                  <font-awesome-icon
                      class="icon times yellow"
                      icon="times-circle"
                      v-else />
                </td>
              </tr>
              <tr>
                <td>Ilość rdzeni procesora</td>
                <td>8</td>
                <td
                    :class="[ requirements.cores === true ? 'pass' : 'can-pass' ]">
                    {{ device.cores }}
                </td>
                <td>
                  <font-awesome-icon
                      class="icon check"
                      icon="check-circle"
                      v-if="requirements.cores === true" />
                  <font-awesome-icon
                      class="icon times yellow"
                      icon="times-circle"
                      v-else />
                </td>
              </tr>
              <tr>
                <td>Ilość dostępnej pamięci</td>
                <td>19GB</td>
                <td
                    :class="[ requirements.freeMemory === true ? 'pass' : 'can-pass' ]">
                    {{ device.freeMemory }}GB
                </td>
                <td>
                  <font-awesome-icon
                      class="icon check"
                      icon="check-circle"
                      v-if="requirements.freeMemory === true" />
                  <font-awesome-icon
                      class="icon times yellow"
                      icon="times-circle"
                      v-else />
                </td>
              </tr>
              <tr>
                <td>Wielkość ekranu</td>
                <td>10 cali</td>
                <td
                    :class="[ requirements.screenSize === true ? 'pass' : 'can-pass' ]">
                    {{ device.screenSize }} cali
                </td>
                <td>
                  <font-awesome-icon
                      class="icon check"
                      icon="check-circle"
                      v-if="requirements.screenSize === true" />
                  <font-awesome-icon
                      class="icon times yellow"
                      icon="times-circle"
                      v-else />
                </td>
              </tr>
              <tr>
                <td>SmartConnect ver 3.1</td>
                <td>TAK</td>
                <td
                    :class="[ requirements.smartConnect === true ? 'pass' : 'no-pass' ]">
                    {{ device.smartConnect ? "TAK" : "NIE" }}
                </td>
                <td>
                  <font-awesome-icon
                      class="icon check"
                      icon="check-circle"
                      v-if="requirements.smartConnect === true" />
                  <font-awesome-icon
                      class="icon times"
                      icon="times-circle"
                      v-else />
                </td>
              </tr>
            </table>
            <div class="about-product">
              <div class="left-row">
                <h1 class="product-name">{{ getProductDetails.name }}</h1>
                <strong>subskrybcja miesięczna</strong>
              </div>
              <div class="right-row">
                <strong>{{ getProductDetails.price }}</strong> <span>Dostęp do systemu</span>
                <info-tooltip class="info-tooltip">Opłata miesięczna za 1 osobę za dostęp do systemu Vocale z
                  pełnymi możliwościami Vocale.</info-tooltip>
              </div>
            </div>
            <div v-if="!requirementsMet" class="requirements-not-met">
              <h1>Parametry urządzenia są niewystarczające <br/> Wybierz jedną z poniższych opcji:</h1>
              <div class="other-options">
                <div class="option">
                  <div>
                    <span>Virtual Smart Connect </span>
                    <span>(+10zł miesięcznie)</span>
                  </div>
                  <BigButton
                      @click="handleSmartConnectAdd"
                      class="big-button"
                      :class="[ smartConnectAdded === true ? 'remove' : 'add' ]"
                      borderColor="primary">{{ smartConnectAdded ? 'Usuń' : 'Dodaj' }}</BigButton>
                </div>
                <div class="option">
                  <div>
                    <div>
                      <span>Vocale Gold</span>
                      <span>(+50zł miesięcznie)</span>
                    </div>
                  </div>
                  <BigButton @click="goToVocaleGold" class="big-button" borderColor="primary">Wybieram</BigButton>
                </div>
                <ul class="gold-features">
                  <li>Tablet <span class="highlight">VOCALE Tab 10 PRO</span></li>
                  <li>Statyw <span class="highlight">VOCALE Tripod</span></li>
                  <li>Etui <span class="highlight">VOCALE Travel Case</span></li>
                  <li>Ładowarka z 3m przewodem</li>
                  <li>Szkło hartowane</li>
                  <li>Certyfikacja Vocale</li>
                </ul>
              </div>
              <Button border-color="primary" text="Skontaktuj się z Opiekunem" @click="contactWithPatron" />
              <span style="margin-top: 1rem;display: block">
                Opiekun skontaktuje się z Tobą w przeciągu najbliższych 24h roboczych
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>
    <TabFooter :buttonEnabled="requirementsMet || smartConnectAdded"
               :name="getProductDetails.name"
               :period="productDetails.period"
               :price="productDetails.price"
               :quantity="productDetails.quantity" @buttonClicked="proceedToSummaryPage"/>
    <PageNotFound v-if="loadError" :message="loadError"/>
    <ContentLoader v-if="!productDetails"/>
  </div>
</template>

<script>
import MainPageHeader from '../components/MainPageHeader.vue'
import PageNotFound from '../components/PageNotFound.vue'
import ContentLoader from '../components/ContentLoader.vue'
import TabFooter from '../components/TabFooter.vue'
import { getAuthService } from '../services/authService'
import { productDatabase } from '@/services/mock/productDatabase'
import { getAndroidContext } from '@/services/sessionProps'
import BigButton from "../components/input/BigButton.vue"
import Button from "../components/input/Button"
import {getAccountService} from "../services/accountService"
import {getCookie} from "../services/sessionProps";
import {getProductService} from "@/services/productService";
import InfoTooltip from '../components/InfoTooltip.vue'

export default {
  name: 'YourDevice',
  components: {
    MainPageHeader,
    PageNotFound,
    ContentLoader,
    TabFooter,
    BigButton,
    Button,
    InfoTooltip
  },

  data () {
    return {
      device: null,
      isLoading: true,
      productDetails: {
        key: '',
        name: '',
        price: '',
        period: '',
        quantity: ''
      },
      loadError: null,
      loggedInEmail: null,
      isAndroidContext: false,
      requirementsMet: null,
      requirements: {
        androidVersion: null,
        ram: null,
        cores: null,
        freeMemory: null,
        screenSize: null,
        smartConnect: null
      },
      smartConnectAdded: false
    }
  },

  computed: {
    getProductId() {
      return sessionStorage.getItem('product')
    },

    getProductDetails() {
      return productDatabase[this.getProductId]
    },
  },

  mounted () {
    window.scrollTo(0,0);
    (async () => {
      let productId = sessionStorage.getItem('product')
      this.productDetails = await getProductService().getProduct(productId)
        .then(product => {
          if(product.subscriptionProlongationDays === 0) {
            product.price = (product.price / 30)
          }
          product.price = (product.price / 100) + 'zł'
          return product
        })
      // this.productDetails = { ...productDatabase[this.$route.params.id] }
      this.isAndroidContext = getAndroidContext().isAndroidContext()
      const [
        loggedInEmail,
      ] = await Promise.all([
        getAuthService().getLoggedInEmail(),
      ])

      await getAccountService().getUserDevice()
      .then(device => {
        this.device = device
        this.checkRequirements()
      })
      .catch(() => {
        console.log('No device')
      })

      this.isLoading = false

      this.loggedInEmail = loggedInEmail
      if (this.loggedInEmail == null) {
        this.$router.replace({
          name: 'logInPage',
          params: {id: this.$route.params.id, fromPage: `products/${this.$route.params.id}/your-device`}
        })
      }
    })()
  },

  methods: {
    handleSmartConnectAdd() {
      if(this.smartConnectAdded === false) {
        this.productDetails.price = (parseInt(this.productDetails.price) + 10 + 'zł').toString()
      } else {
        this.productDetails.price = (parseInt(this.productDetails.price) - 10 + 'zł').toString()
      }

      this.smartConnectAdded = this.smartConnectAdded !== true
    },

    goToVocaleGold() {
      sessionStorage.setItem('product', "2")
      this.$router.push({
        name: 'summaryPage'
      })
    },

    async contactWithPatron(e) {
      e.target.disabled = 1
      e.target.title = "Prośba o kontakt została już wysłana"

      let email = getCookie('loggedInEmail'),
          content = 'Wiadomość automatyczna: Klient prosi o kontakt podczas dodawania karty!'

      await getAccountService().sendFeedback(email, 2, content)

      this.$root.showSnackbar("Twój Opiekun skontaktuje się z Tobą w przeciągu 24h roboczych.", "success")
    },

    checkRequirements() {
      let device = this.device
      this.requirements = {
        androidVersion: device.androidVersion >= 8,
        ram: device.ram >= 4,
        cores: device.cores >= 8,
        freeMemory: device.freeMemory >= 19,
        screenSize: device.screenSize >= 10,
        smartConnect: device.smartConnect
      }

      this.requirementsMet = device.androidVersion >= 8 && device.smartConnect === true
    },

    goToPlaystore() {
      this.$router.push({ path: '/campaign/play-store/website' })
    },

    acceptAllInput () {
      if (this.policyStates.some(p => p == false)) {
        this.policyStates = this.policyStates.map(p => true)
      } else {
        this.policyStates = this.policyStates.map(p => false)
      }
    },

    policyInput (index, state) {
      const states = this.policyStates.slice()
      states[index] = !this.policyStates[index]
      this.policyStates = states
    },

    proceedToSummaryPage () {
      if (this.loggedInEmail != null) {
        if(this.smartConnectAdded) {
          sessionStorage.setItem("product", "4")
        }
        this.$router.push({ name: 'summaryPage', params: {
          product: this.productDetails,
          hasSmartConnect: this.device.smartConnect || this.smartConnectAdded
        } })
      } else {
        this.$router.push({ name: 'logInPage', params: { id: this.$route.params.id } })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.highlight {
  color: $gold;
}

.description {
  font-weight: bold;
  margin-bottom: 2rem;
  display: block;
  font-size: 18px;
}

.TabPage {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  grid-template-areas: 'header'
            'content'
            'footer';
  min-height: 100vh;
}

.MainPageHeader {
  grid-area: header;
}

.Footer {
  grid-area: footer;
}

.content {
  grid-area: content;

  padding: 0 20px;
  margin-top: 140px;
  margin-bottom: 100px;

  // Mobile style
  @media (max-width: $phone-max-width) {

    margin-top: 100px;

  }

  header.main-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 auto;
    max-width: 1300px;

    p {
      font-weight: bold;
    }

    h1 {
      margin-left: 20px;
      color: $primary;
    }
  }

  .text-header {
    padding: 20px 0;
    text-align: center;
    color: white;

    h1 {
      color: $primary;
    }

    h2 {
      color: $primary;
      font-weight: normal;
    }

    // Mobile style
    @media (max-width: $phone-max-width) {

      padding: 10px 0;
      margin-bottom: 20px;

      h1 {
        margin: 0;
      }
    }
  }

  .section {
    display: block;
    margin: 0 auto;
    margin-bottom: 30px;
    padding: 20px 30px;
    max-width: 1000px;
    border: 1px solid #aaa;

    header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      p {
        margin: 0;
        color: #ddd;
      }

      .image-placeholder {
        width: 40px;
        height: 30px;
        background-color: white;
      }
    }

    .info {
      flex: 1 1;

      .red-info {
        color: red;
      }

      .accept-all {
        font-weight: bold;
      }

      .inset {
        margin-left: 60px;
      }

      .yellow-link {
        color: $primary;
        text-decoration: underline;
        cursor: pointer;
      }

      // Mobile style
      @media (max-width: $phone-max-width) {
        .inset {
          margin-left: 20px;
        }
      }
    }

    .big-button {
      display: block;
      margin: auto;
      margin-bottom: 2rem;
      &.add {
        border-color: #36ce36;
        color: #36ce36;
      }

      &.remove {
        border-color: #ce3346;
        color: #ce3346;
      }

      // Mobile style
      @media (max-width: $phone-max-width) {
        width: 100%;
        min-width: unset;
      }
    }
  }

  .section-1 {
    text-align: center;
    border-color: $primary;

    // Mobile style
    @media (max-width: $phone-max-width) {
      padding: 0;
      border: none;
    }
  }

  .divider {
    border-bottom: 1px solid #aaa;
  }
}

.android-content {
  margin-top: 30px;
}

.loader {
  width: 20px;
  margin: 1px;
  font-size: 10px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  text-indent: -9999em;
  border-top: 0.5em solid $primary;
  border-right: 0.5em solid $primary;
  border-bottom: 0.5em solid $primary;
  border-left: 0.5em solid #ffffff;
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 0.8s infinite linear;
}

.loader,
.loader:after {
  border-radius: 100%;
  width: 5em;
  height: 5em;
}

@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

table.comparing {
  font-weight: bold;
  max-width: 480px;
  width: 100%;
  margin: auto;
  tr {
    &:first-child {
      color: $gold;
    }
    td {
      &:last-child {
        @media (max-width: $phone-max-width) {
          display: none;
        }
      }
      padding: 4px 8px;
      &.pass {
        color: #36ce36;
      }
      &.can-pass {
        color: #c9b536;
      }
      &.no-pass {
        color: #ce3346;
      }
      .icon.times {
        color: #ce3346;
      }
      .icon.times.yellow {
        color: #c9b536;
      }
      .icon.check {
        color: #36ce36;
      }
      &:first-child {
        text-align: left;
      }
    }
  }
}

.about-product {
  margin: 3rem auto;
  display: flex;
  max-width: 480px;
  justify-content: space-between;
  align-items: center;
  @media (max-width: $phone-max-width) {
    display: block;
  }
  .left-row {
    .product-name {
      font-size: 32px;
      color: $gold;
      margin: 0;
    }
  }
  .right-row .info-tooltip {
    color: red;
    margin-left: 4px;
  }
}

.requirements-not-met {
  & > .big-button {
    max-width: 1000px;
    width: 100%;
  }
  h1 {
    color: $gold;
  }
  .other-options {
    display: block;
    max-width: 480px;
    margin: auto;
    .gold-features {
      padding: 0;
      text-align: left;
      .highlight {
        font-weight: bold;
      }
      @media (max-width: $phone-max-width) {
        margin-left: 4rem;
      }
    }
    .option {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 2rem;
      span {
        font-weight: bold;
      }
      .big-button {
        margin: 0;
        margin-left: 2rem;
      }
      @media (max-width: $phone-max-width) {
        &>:first-child {
          flex: 2;
          span {
            display: block;
          }
        }
        &>:nth-child(2) {
          flex: 1;
        }
      }
    }
  }
}
</style>